import styles from './ColoredDot.module.scss';

type ColoredDotProps = {
    color?: string | null;
};

export const ColoredDot = ({ color }: ColoredDotProps): JSX.Element => {
    return (
        <span
            className={styles.wrap}
            style={{ backgroundColor: color ?? 'var(--white)' }}
        />
    );
};

export default ColoredDot;
